import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import "./style/LoginPromptModal.css";

const LoginPromptModal = ({ isOpen, onClose, source = "unknown" }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Lock body scroll when open
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      ReactGA.event({ category: "conversion", action: "signup_prompt", label: source });
    }
  }, [isOpen, source]);

  if (!isOpen) return null;

  const handleLogin = () => {
    onClose();
    navigate("/login", { state: { from: location } });
  };

  const handleSignup = () => {
    onClose();
    navigate({ pathname: "/signup", search: `?from=${source}` }, { state: { from: location } });
  };

  return (
    <div className="lpm-overlay" onClick={onClose}>
      <div className="lpm-card" onClick={(e) => e.stopPropagation()}>
        {/* Close */}
        <button className="lpm-close" onClick={onClose} aria-label="Close">
          ✕
        </button>

        {/* Icon */}
        <div className="lpm-icon">
          <img src="/logo_only.png" alt="Logo" style={{ height: "30px" }} />
        </div>

        {/* Title */}
        <h2 className="lpm-title">
          <img
            src="/logo_txt_only.png"
            alt="Logo"
            style={{ height: "30px" }}
          />
        </h2>
        <p className="lpm-sub">
          Create a free account to like, comment
          <br />
          and share photos at this event.
        </p>

        {/* Actions */}
        <div className="lpm-actions">
          <button className="lpm-btn lpm-btn--primary" onClick={handleLogin}>
            Log in
          </button>
          <button className="lpm-btn lpm-btn--secondary" onClick={handleSignup}>
            Sign up free
          </button>
        </div>

        <p className="lpm-footer">No credit card required.</p>
      </div>
    </div>
  );
};

export default LoginPromptModal;
